import React from 'react';
import SgsstCrudPage from '../components/SgsstCrudPage';
import { sgsstPresupuesto } from '../services/api';

const yNow = new Date().getFullYear();

export default function SgsstPresupuesto() {
  return (
    <SgsstCrudPage
      title="Presupuesto SG-SST"
      sub="Rubros presupuestados y su ejecución."
      newLabel="+ Nuevo rubro"
      api={sgsstPresupuesto}
      vacio={{ anio: yNow, rubro: '', descripcion: '', presupuestado: 0, ejecutado: 0, observacion: '' }}
      columns={[
        { k: 'anio', h: 'Año', mono: true }, { k: 'rubro', h: 'Rubro', strong: true }, { k: 'presupuestado', h: 'Presupuestado', fmt: 'money' },
        { k: 'ejecutado', h: 'Ejecutado', fmt: 'money' },
      ]}
      fields={[
        { k: 'anio', l: 'Año', type: 'number' }, { k: 'rubro', l: 'Rubro', type: 'text' },
        { k: 'descripcion', l: 'Descripción', type: 'textarea', full: true },
        { k: 'presupuestado', l: 'Valor presupuestado', type: 'number', step: '1000' }, { k: 'ejecutado', l: 'Valor ejecutado', type: 'number', step: '1000' },
        { k: 'observacion', l: 'Observación', type: 'text', full: true },
      ]}
    />
  );
}
